module.exports = __webpack_public_path__ + "img/folder-outline.0f84e37b.svg";